<template>
  <!-- 微信支付 -->
  <el-dialog
    title="微信支付"
    :visible.sync="dialogVisible"
    width="30%"
    @open="open"
    :before-close="handleClose"
    destroy-on-close
  >
    <div id="payQrcode"></div>
    <!-- <span>这是一段信息</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
import { weiXinNativePay, getOrderStatus } from "@/api/platform";
import QRCode from "qrcodejs2"; // 生成二维码

export default {
  data() {
    return {
      dialogVisible: false,
      timeOut: null,
      order_num: null,
    };
  },
  props: {
    pay_amount: {
      type: Number,
      default: () => 0,
    },
  },
  components: {},
  created() {},
  computed: {},
  mounted() {},
  methods: {
    async open() {
      const { pay_amount } = this;
      const { result } = await weiXinNativePay({
        sign: "kePuTe",
        goods_text: "科普特商城",
        pay_amount:0.01,
      });
      this.order_num = result.data.order_num;
      this.GenerateQRcode(result.data.code_url);
      this.getOrderStatus();
    },
    // 生成二维码
    GenerateQRcode(val) {
      new QRCode("payQrcode", {
        // 此处的qrcode为上面div的id
        text: val,
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    getOrderStatus() {
      const { order_num } = this;
      this.timer = setInterval(async () => {
        const { result } = await getOrderStatus({
          order_num,
        });
        if (result.data.status === 2) {
          clearInterval(this.timer);
          this.$notify({
            title: "提示",
            message: "支付成功",
            type: "success",
          });
          this.dialogVisible = false;
          setTimeout(() => {
            this.$emit("wxPaySuccess");
          }, 2000);
        }
      }, 3000);
    },
    handleClose() {
      clearInterval(this.timer);
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
#payQrcode {
  width: 200px;
  height: 200px;
}
/deep/.el-dialog__body {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/wxPay.vue